module.exports = __webpack_public_path__ + "img/badge-list-thumb-021.4d75ae76.png";